module.exports = __webpack_public_path__ + "img/65en.87487c10.png";